import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUser } from 'context/UserContext'
import { ButtonWrapper } from 'components/ButtonWrapper'
import { ChoiceButton } from 'components/ChoiceButton'
import { Heading } from 'components/Heading'

interface Props {
  nextRoute: string
}

export const Diet: React.FC<Props> = ({ nextRoute }) => {
  const { t } = useTranslation('translation', {
    useSuspense: false,
  })

  const navigate = useNavigate()
  const { user, setUser } = useUser()

  const onButtonClick = (diet: string) => {
    setUser({ ...user, diet })
    navigate(nextRoute)
  }

  return (
    <div className="default-container flex flex-col bg-diet bg-center">
      <div className="flex h-full w-full flex-col justify-between self-center overflow-auto px-7 pb-10 pt-7 lg:w-5/6 xl:w-5/12">
        <Heading text={t('diet.headline')} />

        <ButtonWrapper>
          <ChoiceButton
            onClick={() => onButtonClick('anything')}
            value={t('diet.diet_1')}
            id="no_preference"
            small
          />
          <ChoiceButton
            onClick={() => onButtonClick('vegetarian')}
            value={t('diet.diet_2')}
            id="vegetarian"
            small
          />
          <ChoiceButton
            onClick={() => onButtonClick('vegan')}
            value={t('diet.diet_3')}
            id="vegan"
            small
          />
          <ChoiceButton
            onClick={() => onButtonClick('keto')}
            value={t('diet.diet_4')}
            id="keto"
            small
          />
          <ChoiceButton
            onClick={() => onButtonClick('other')}
            value={t('diet.diet_5')}
            id="other"
            small
          />
        </ButtonWrapper>
      </div>
    </div>
  )
}
